export default function () {
  return {
  };
}
